import { createTranslations } from '@npco/utils-translations'

export const readyToGoStageTranslations = createTranslations({
  title: "It's ready to go now",
  description:
    'Start using your Zeller Savings Account instantly. Simply activate it by adding your Tax File Number, then transfer funds in from any Zeller Transaction Account.',
  activate: 'Activate',
})
